document.addEventListener('DOMContentLoaded', function() {
  // Initialize all countdown timers on the page
  const countdownBanners = document.querySelectorAll('.countdown-banner');
  
  countdownBanners.forEach(function(banner) {
    initializeCountdown(banner);
  });
  
  // Function to get next midnight in US Eastern Timezone
  function getNextMidnightUSTimezone() {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    
    // Get current time in US Eastern
    const parts = formatter.formatToParts(now);
    const currentYear = parseInt(parts.find(p => p.type === 'year').value);
    const currentMonth = parseInt(parts.find(p => p.type === 'month').value);
    const currentDay = parseInt(parts.find(p => p.type === 'day').value);
    const currentHour = parseInt(parts.find(p => p.type === 'hour').value);
    const currentMinute = parseInt(parts.find(p => p.type === 'minute').value);
    const currentSecond = parseInt(parts.find(p => p.type === 'second').value);
    
    // Calculate milliseconds until next midnight in US Eastern
    const currentTimeMs = (currentHour * 3600 + currentMinute * 60 + currentSecond) * 1000;
    const dayMs = 24 * 3600 * 1000;
    const msUntilMidnight = dayMs - currentTimeMs;
    
    // Create target date (next midnight in US Eastern)
    const targetDateStr = `${currentYear}-${String(currentMonth).padStart(2, '0')}-${String(currentDay).padStart(2, '0')}`;
    const targetTimeStr = '00:00';
    
    // Parse and add 24 hours if we're past midnight
    let targetDate = parseDateInUSTimezone(targetDateStr, targetTimeStr);
    
    // If we've already passed midnight today, target tomorrow's midnight
    if (targetDate.getTime() <= now.getTime()) {
      const tomorrow = new Date(targetDate.getTime() + dayMs);
      const tomorrowParts = formatter.formatToParts(tomorrow);
      const tomorrowYear = parseInt(tomorrowParts.find(p => p.type === 'year').value);
      const tomorrowMonth = parseInt(tomorrowParts.find(p => p.type === 'month').value);
      const tomorrowDay = parseInt(tomorrowParts.find(p => p.type === 'day').value);
      const tomorrowDateStr = `${tomorrowYear}-${String(tomorrowMonth).padStart(2, '0')}-${String(tomorrowDay).padStart(2, '0')}`;
      targetDate = parseDateInUSTimezone(tomorrowDateStr, targetTimeStr);
    }
    
    return targetDate;
  }
  
  // Function to parse date in US Eastern Timezone
  function parseDateInUSTimezone(dateStr, timeStr) {
    // Parse the date components
    const [year, month, day] = dateStr.split('-').map(Number);
    const [hours, minutes] = timeStr.split(':').map(Number);
    
    // Create a date string that represents the target time in US Eastern
    // We need to find the UTC time that equals this US Eastern time
    
    // Use iterative approach to find the correct UTC time
    // Start with an estimate: US Eastern is typically UTC-5 (EST) or UTC-4 (EDT)
    let targetUTC = Date.UTC(year, month - 1, day, hours + 5, minutes, 0); // Start with EST offset
    
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    
    // Iterate to find the exact UTC time
    for (let i = 0; i < 10; i++) {
      const checkDate = new Date(targetUTC);
      const parts = formatter.formatToParts(checkDate);
      const checkYear = parseInt(parts.find(p => p.type === 'year').value);
      const checkMonth = parseInt(parts.find(p => p.type === 'month').value);
      const checkDay = parseInt(parts.find(p => p.type === 'day').value);
      const checkHour = parseInt(parts.find(p => p.type === 'hour').value);
      const checkMinute = parseInt(parts.find(p => p.type === 'minute').value);
      
      // Check if we've found the correct time
      if (checkYear === year && checkMonth === month && checkDay === day && 
          checkHour === hours && checkMinute === minutes) {
        break; // Found it!
      }
      
      // Calculate the difference
      // Create dates in local time to compare
      const checkLocal = new Date(checkYear, checkMonth - 1, checkDay, checkHour, checkMinute, 0);
      const targetLocal = new Date(year, month - 1, day, hours, minutes, 0);
      const diffMs = targetLocal.getTime() - checkLocal.getTime();
      
      // Adjust UTC time
      targetUTC += diffMs;
      
      // Prevent infinite loop if difference is too small
      if (Math.abs(diffMs) < 1000) break;
    }
    
    return new Date(targetUTC);
  }
  
  function initializeCountdown(bannerElement) {
    const timerElement = bannerElement.querySelector('.countdown-banner__timer');
    if (!timerElement) return;
    
    // Get countdown mode and settings
    const countdownMode = bannerElement.getAttribute('data-countdown-mode') || 'daily_24h';
    const targetDateStr = bannerElement.getAttribute('data-target-date');
    const targetTimeStr = bannerElement.getAttribute('data-target-time') || '23:59';
    const showDays = bannerElement.getAttribute('data-show-days') === 'true';
    const showTimerAfterExpired = bannerElement.getAttribute('data-show-timer-after-expired') === 'true';
    
    let targetDate;
    
    if (countdownMode === 'daily_24h') {
      // Daily 24h countdown - reset at midnight US Eastern time
      const sessionKey = 'countdown_banner_daily_24h';
      const savedDate = localStorage.getItem(sessionKey);
      const savedTimestamp = savedDate ? parseInt(savedDate) : null;
      const now = new Date().getTime();
      
      // Check if saved date is still valid (not expired and same day in US Eastern)
      if (savedTimestamp && savedTimestamp > now) {
        const savedDateObj = new Date(savedTimestamp);
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
        
        const savedParts = formatter.formatToParts(savedDateObj);
        const nowParts = formatter.formatToParts(new Date());
        
        const savedDay = savedParts.find(p => p.type === 'day').value;
        const nowDay = nowParts.find(p => p.type === 'day').value;
        const savedMonth = savedParts.find(p => p.type === 'month').value;
        const nowMonth = nowParts.find(p => p.type === 'month').value;
        const savedYear = savedParts.find(p => p.type === 'year').value;
        const nowYear = nowParts.find(p => p.type === 'year').value;
        
        // If same day, use saved date
        if (savedDay === nowDay && savedMonth === nowMonth && savedYear === nowYear) {
          targetDate = savedDateObj;
        } else {
          // New day, get next midnight
          targetDate = getNextMidnightUSTimezone();
          localStorage.setItem(sessionKey, targetDate.getTime().toString());
        }
      } else {
        // No saved date or expired, get next midnight
        targetDate = getNextMidnightUSTimezone();
        localStorage.setItem(sessionKey, targetDate.getTime().toString());
      }
    } else if (countdownMode === 'specific_date' && targetDateStr) {
      // Use custom date from settings
      try {
        // Parse date and time in US Eastern Time (America/New_York)
        targetDate = parseDateInUSTimezone(targetDateStr, targetTimeStr);
        
        // Validate date
        if (isNaN(targetDate.getTime())) {
          targetDate = getNextMidnightUSTimezone();
        }
      } catch (e) {
        targetDate = getNextMidnightUSTimezone();
      }
    } else {
      // Fallback: if specific_date mode but no date provided, use daily 24h
      // Otherwise use daily 24h as default
      targetDate = getNextMidnightUSTimezone();
    }
    
    // Get timer elements
    const daysElement = showDays ? timerElement.querySelector('#countdown-days') : null;
    const hoursElement = timerElement.querySelector('#countdown-hours');
    const minutesElement = timerElement.querySelector('#countdown-minutes');
    const secondsElement = timerElement.querySelector('#countdown-seconds');
    
    if (!hoursElement || !minutesElement || !secondsElement) {
      return;
    }
    
    // Update countdown every second
    const countdownInterval = setInterval(function() {
      updateCountdown(
        targetDate, 
        daysElement, 
        hoursElement, 
        minutesElement, 
        secondsElement, 
        bannerElement, 
        countdownInterval,
        countdownMode,
        showDays,
        showTimerAfterExpired
      );
    }, 1000);
    
    // Initial update
    updateCountdown(
      targetDate, 
      daysElement, 
      hoursElement, 
      minutesElement, 
      secondsElement, 
      bannerElement, 
      countdownInterval,
      countdownMode,
      showDays,
      showTimerAfterExpired
    );
  }
  
  
  function updateCountdown(targetDate, daysElement, hoursElement, minutesElement, secondsElement, bannerElement, interval, countdownMode, showDays, showTimerAfterExpired) {
    const now = new Date().getTime();
    let distance = targetDate.getTime() - now;
    
    // If countdown is finished
    if (distance < 0) {
      // For daily 24h mode, reset to next midnight
      if (countdownMode === 'daily_24h') {
        const newTargetDate = getNextMidnightUSTimezone();
        const sessionKey = 'countdown_banner_daily_24h';
        localStorage.setItem(sessionKey, newTargetDate.getTime().toString());
        targetDate = newTargetDate;
        distance = targetDate.getTime() - now;
      } else {
        // For specific date mode, show expired state
        clearInterval(interval);
        if (daysElement) daysElement.textContent = '00';
        hoursElement.textContent = '00';
        minutesElement.textContent = '00';
        secondsElement.textContent = '00';
        
        // Add expired class to banner
        bannerElement.classList.add('expired');
        
        // Get elements
        const timerContainer = bannerElement.querySelector('[data-timer-container]');
        const textElement = bannerElement.querySelector('[data-text-element]');
        const expiredTextElement = bannerElement.querySelector('[data-expired-text]');
        
        // Handle timer visibility based on settings
        if (timerContainer) {
          if (!showTimerAfterExpired) {
            timerContainer.style.display = 'none';
          } else {
            timerContainer.style.display = 'flex';
          }
        }
        
        // Hide normal text and show expired text
        if (textElement) {
          textElement.style.display = 'none';
        }
        
        if (expiredTextElement) {
          expiredTextElement.style.display = 'block';
        }
        
        // Center the content
        const contentElement = bannerElement.querySelector('.countdown-banner__content');
        if (contentElement) {
          contentElement.style.justifyContent = 'center';
        }
        
        return;
      }
    }
    
    // Calculate time units
    const days = showDays ? Math.floor(distance / (1000 * 60 * 60 * 24)) : 0;
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    // Update display with animation
    if (daysElement && showDays) {
      updateTimeDisplay(daysElement, days, 2);
    }
    updateTimeDisplay(hoursElement, hours, 2);
    updateTimeDisplay(minutesElement, minutes, 2);
    updateTimeDisplay(secondsElement, seconds, 2);
  }
  
  function updateTimeDisplay(element, value, minDigits = 2) {
    const formattedValue = value.toString().padStart(minDigits, '0');
    
    if (element.textContent !== formattedValue) {    
      // Update value
      element.textContent = formattedValue;
    }
  }
  
  // Optional: Add functionality to reset countdown
  window.countdownBanner = {
    reset: function() {
      // Clear localStorage and reload page to restart countdown
      localStorage.removeItem('countdown_banner_daily_24h');
      location.reload();
    },
    getTimeRemaining: function() {
      // Get remaining time for daily 24h countdown
      const savedEndTime = localStorage.getItem('countdown_banner_daily_24h');
      if (savedEndTime) {
        const now = new Date().getTime();
        const distance = parseInt(savedEndTime) - now;
        return Math.max(0, distance);
      }
      return 0;
    }
  };
});
